import { GRAY_1, GRAY_3 } from './mc-tokens';

export const MODUS_EMPTY_STYLESHEET = `
  .empty {
    display: flex;
    flex-flow: column nowrap;
    align-items: center;
    justify-content: center;
    max-width: 14.5rem;
    min-height: 14.5rem;
    margin: 0 auto;
    height: 100%;
  }

  .empty.small {
    min-width: 14.5rem;
  }

  .empty.small .empty-icon {
    min-height: 2.5rem;
    min-width: 2.5rem;
    margin-bottom: 0;
    padding: 0;
    background-color: transparent;
    color: ${GRAY_3};
    font-size: 2.5rem;
  }

  .empty.small .empty-icon > .icon-font,
  .empty.small .empty-icon modus-wc-icon,
  .empty.small .empty-icon modus-wc-icon .icon-font {
    min-height: 2.5rem;
    min-width: 2.5rem;
    font-size: 2.5rem;
  }

  .empty.small .empty-text {
    margin: 0.5rem 0.25rem;
  }

  .empty .empty-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 14.5rem;
    min-height: 14.5rem;
    padding: 5rem;
    border-radius: 50%;
    margin-bottom: 1rem;
    background-color: ${GRAY_1};
  }

  .empty .empty-icon > .icon-font,
  .empty .empty-icon modus-wc-icon,
  .empty .empty-icon modus-wc-icon .icon-font {
    min-width: 4.5rem;
    min-height: 4.5rem;
    color: ${GRAY_3};
    font-size: 4.5rem;
  }

  .empty .empty-text {
    margin-bottom: 1rem;
    text-align: center;
  }
`;
